import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-multiply",
  "use": "icon-multiply-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-multiply\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.176 0L4.676 3.5L1.177 0L0 1.177L3.5 4.677L0 8.176L1.177 9.354L4.676 5.854L8.176 9.354L9.353 8.176L5.853 4.677L9.353 1.177L8.176 0Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol